import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { TrackingConstant } from 'client/tracking/constant';
import { generateTrackingIds } from 'site-modules/shared/utils/make-model-zip';
import { getSearchByModuleTrackingMap } from 'client/tracking/maps/common/search-by-module';
import { QB_66_LINK_OVERRIDES_BY_CHAL_RECIPE } from 'site-modules/shared/constants/top-links-section-qb-66/constants';

const PAGE_NAME = 'new_cars_index';
export const MMZ_TRACKING_IDS = generateTrackingIds(PAGE_NAME);

const map = {
  [MMZ_TRACKING_IDS.makeSelectTrackingId]: TrackingEvent.actionStart(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.MAKE_SELECT
  ),

  [MMZ_TRACKING_IDS.modelSelectTrackingId]: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.MODEL_SELECT
  ),

  [MMZ_TRACKING_IDS.submitTrackingId]: TrackingEvent.actionEnd(
    TrackingConstant.ACTION_MMY_SELECT,
    TrackingConstant.SUBMIT_MMY
  ),

  ...getSearchByModuleTrackingMap(MMZ_TRACKING_IDS),

  search_vehicles: TrackingEvent.actionEnd(TrackingConstant.ACTION_WHY_EDMUNDS, TrackingConstant.SEARCH_INVENTORY),

  search_deals: TrackingEvent.actionEnd(TrackingConstant.ACTION_WHY_EDMUNDS, TrackingConstant.SEARCH_DEALS),

  search_perfect_car: TrackingEvent.actionEnd(
    TrackingConstant.ACTION_WHY_EDMUNDS,
    TrackingConstant.FIND_MY_PERFECT_CAR
  ),
};

export const TrackingMap = {
  ...CommonMap,
  ...map,
};

export const getQb66TrackingMapOverridesByChalRecipe = chalRecipe => {
  if (!(chalRecipe in QB_66_LINK_OVERRIDES_BY_CHAL_RECIPE)) {
    return {}; // ctrl = do NOT override
  }
  return {
    link_select_tool_select_qb66: TrackingEvent.actionCompleted(
      TrackingConstant.ACTION_TOOL_SELECT,
      TrackingConstant.QUOTE_BOT_START
    ),
  };
};
